import { Box, Card, CardHeader, List, ListItem, TextField, InputAdornment } from '@mui/material'
import pic1 from '../images/grid/CSForAll.png'
import pic2 from '../images/grid/city-explorer-mobile.png'
import pic3 from '../images/grid/carousel-of-coders-cropped.png'
import pic4 from '../images/grid/stormy-music-screensho.png'
import pic5 from '../images/grid/vibe_social_login.png'
import pic6 from '../images/grid/kny-survey.png'

import portfolio from "../portfolio.json";

export const Sidebar = () => {
    const { social } = portfolio.basic_info
    return (
      <Box sx={sidebarContainerStyles}>
        {/* Search Bar */}
        <Box sx={searchContainerStyles}>
          <TextField
            sx={searchInputStyles}
            placeholder="Search"
            variant="outlined"
            fullWidth
            disabled
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <i className="fa-solid fa-magnifying-glass" style={{ color: '#536471' }}></i>
                </InputAdornment>
              ),
            }}
          />
        </Box>

        {/* Project Grid */}
        <Box sx={imgGridStyles}>
          <Box component="img" alt='pic' src={pic1} sx={picStyles} />
          <Box component="img" alt='pic' src={pic2} sx={picStyles} />
          <Box component="img" alt='pic' src={pic3} sx={picStyles} />
          <Box component="img" alt='pic' src={pic4} sx={picStyles} />
          <Box component="img" alt='pic' src={pic5} sx={picStyles} />
          <Box component="img" alt='pic' src={pic6} sx={picStyles} />
        </Box>

        {/* Social Links Card */}
        <Card sx={cardStyles}>
          <CardHeader title={social[0]} />
          <List>
            <ListItem>
              <i className={social[1].class}> <a href={social[1].url} target="_blank" rel="noreferrer">{social[1].name}</a> </i>
            </ListItem>
            <ListItem>
            <i className={social[2].class}> <a href={social[2].url} target="_blank" rel="noreferrer">{social[2].name}</a> </i>
            </ListItem>
          </List>
        </Card>
      </Box>
    )
  }

const sidebarContainerStyles = {
  width: '350px',
  padding: '0 16px',
  paddingTop: '12px',
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
  backgroundColor: '#fff',
  position: 'sticky',
  top: 0,
  height: '100vh',
  overflowY: 'auto',
  '@media (max-width: 1100px)': {
    display: 'none',
  },
};

const searchContainerStyles = {
  position: 'sticky',
  top: '12px',
  zIndex: 10,
  marginBottom: '8px',
};

const searchInputStyles = {
  '& .MuiOutlinedInput-root': {
    borderRadius: '9999px',
    backgroundColor: '#eff3f4',
    '& fieldset': {
      borderColor: 'transparent',
    },
    '&:hover fieldset': {
      borderColor: 'transparent',
    },
    '&.Mui-focused': {
      backgroundColor: '#fff',
      '& fieldset': {
        borderColor: '#1d9bf0',
        borderWidth: '1px',
      },
    },
  },
  '& .MuiInputBase-input': {
    padding: '12px 16px',
    fontSize: '15px',
    color: '#0f1419',
  },
};

const imgGridStyles = {
  display: 'grid',
  gridTemplateColumns: 'repeat(3, 1fr)',
  gap: '2px',
  borderRadius: '16px',
  overflow: 'hidden',
  '@media (max-width: 1249px)': {
    gridTemplateColumns: '1fr 1fr',
    gridTemplateRows: 'repeat(3, 1fr)',
  },
};

const picStyles = {
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  aspectRatio: 1,
};

const cardStyles = {
  '& .MuiCard-root': {
    border: '1px solid #e1e8ed',
    borderRadius: '16px',
    overflow: 'hidden',
    backgroundColor: '#f7f9fa',
  },
  '& .MuiCardHeader-root': {
    backgroundColor: 'transparent',
    borderBottom: '1px solid #e1e8ed',
    padding: '12px 16px',
  },
  '& .MuiCardHeader-title': {
    fontSize: '20px',
    fontWeight: 700,
    color: '#14171a',
  },
  '& .MuiListItem-root': {
    border: 'none',
    borderBottom: '1px solid #e1e8ed',
    padding: '12px 16px',
    backgroundColor: 'transparent',
    fontSize: '15px',
    '&:last-child': {
      borderBottom: 'none',
    },
    '& i': {
      marginRight: '8px',
      fontSize: '18px',
    },
  },
};
